import { render, staticRenderFns } from "./WeekChart.vue?vue&type=template&id=01845d94&lang=pug"
import script from "./WeekChart.vue?vue&type=script&lang=js"
export * from "./WeekChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports